import { render, staticRenderFns } from "./handleCom.vue?vue&type=template&id=7c756ea2&scoped=true&"
import script from "./handleCom.vue?vue&type=script&lang=js&"
export * from "./handleCom.vue?vue&type=script&lang=js&"
import style0 from "./handleCom.vue?vue&type=style&index=0&id=7c756ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c756ea2",
  null
  
)

component.options.__file = "handleCom.vue"
export default component.exports